import React, { useEffect } from 'react';
import { useLocaleDetails } from '../../hooks/use-locale-details';
import { useAnalyticsConsent } from '../../services/analytics/analytics-consent.service';
import { FirstTouchAttributionService } from '../../services/analytics/first-touch-attribution.service';

const FirstTouchAttribution: React.FC = () => {
    const consent = useAnalyticsConsent();
    const { localeCode, locationCode } = useLocaleDetails();

    useEffect(() => {
        if (consent === 'accepted') FirstTouchAttributionService.capture(localeCode, locationCode);
    }, [consent, localeCode, locationCode]);

    return null;
};

export default FirstTouchAttribution;
